export default __webpack_public_path__ + "static/media/promo-vip-banner-ms.58499926.webp";